import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { connect } from 'react-redux';

const PublicRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            component={ props =>
                !rest.isLoggedIn 
                ? <Component {...props} />
                : <Redirect to='' />
            }
        />
    )
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.isLoggedIn
    }
}

export default connect(mapStateToProps)(PublicRoute);
